/**
 * @flow
 * @relayHash fe38c8acc30755899c3a147bbc9a8afa
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type AppManagementDeleteBlacklistedPhraseInput = {|
  id: string,
  clientMutationId?: ?string,
|};
export type ChatConfigContainerDeleteBlacklistedPhraseMutationVariables = {|
  input: AppManagementDeleteBlacklistedPhraseInput
|};
export type ChatConfigContainerDeleteBlacklistedPhraseMutationResponse = {|
  +appManagementDeleteBlacklistedPhrase: ?{|
    +success: ?boolean,
    +errors: ?$ReadOnlyArray<?{|
      +statusCode: ?number,
      +message: ?string,
      +meta: ?any,
      +errorCode: ?string,
      +code: ?number,
    |}>,
  |}
|};
export type ChatConfigContainerDeleteBlacklistedPhraseMutation = {|
  variables: ChatConfigContainerDeleteBlacklistedPhraseMutationVariables,
  response: ChatConfigContainerDeleteBlacklistedPhraseMutationResponse,
|};
*/


/*
mutation ChatConfigContainerDeleteBlacklistedPhraseMutation(
  $input: AppManagementDeleteBlacklistedPhraseInput!
) {
  appManagementDeleteBlacklistedPhrase(input: $input) {
    success
    errors {
      statusCode
      message
      meta
      errorCode
      code
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "AppManagementDeleteBlacklistedPhraseInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "appManagementDeleteBlacklistedPhrase",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "AppManagementDeleteBlacklistedPhrasePayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "success",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "errors",
        "storageKey": null,
        "args": null,
        "concreteType": "AppManagementError",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "statusCode",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "message",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "meta",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "errorCode",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "code",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "ChatConfigContainerDeleteBlacklistedPhraseMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "ChatConfigContainerDeleteBlacklistedPhraseMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "ChatConfigContainerDeleteBlacklistedPhraseMutation",
    "id": null,
    "text": "mutation ChatConfigContainerDeleteBlacklistedPhraseMutation(\n  $input: AppManagementDeleteBlacklistedPhraseInput!\n) {\n  appManagementDeleteBlacklistedPhrase(input: $input) {\n    success\n    errors {\n      statusCode\n      message\n      meta\n      errorCode\n      code\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '430335131a78cb32cb91e92382aeac86';
module.exports = node;
